import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ProgressBarService } from '../progress-bar.service';
import { MatProgressBar } from '@angular/material/progress-bar';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
  selector: 'app-progress-bar',
  styleUrls: ['./progress-bar.component.scss'],
  templateUrl: './progress-bar.component.html',
  imports: [MatProgressBar],
})
export class ProgressBarComponent implements OnInit, OnDestroy {
  public bufferValue: number;
  public mode: 'determinate' | 'indeterminate' | 'buffer' | 'query';
  public value: number;
  public visible: boolean;

  private _changeDetectorRef = inject(ChangeDetectorRef);
  private _progressBarService = inject(ProgressBarService);
  // Private
  private _unsubscribeAll$: Subject<void> = new Subject();

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On destroy
   */
  public ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  /**
   * On init
   */
  public ngOnInit(): void {
    // Subscribe to the progress bar service properties

    // Buffer value
    this._progressBarService.bufferValue.pipe(takeUntil(this._unsubscribeAll$)).subscribe((bufferValue) => {
      this.bufferValue = bufferValue;
      this._changeDetectorRef.markForCheck();
    });

    // Mode
    this._progressBarService.mode.pipe(takeUntil(this._unsubscribeAll$)).subscribe((mode) => {
      this.mode = mode;
      this._changeDetectorRef.markForCheck();
    });

    // Value
    this._progressBarService.value.pipe(takeUntil(this._unsubscribeAll$)).subscribe((value) => {
      this.value = value;
      this._changeDetectorRef.markForCheck();
    });

    // Visible
    this._progressBarService.visible.pipe(takeUntil(this._unsubscribeAll$)).subscribe((visible) => {
      this.visible = visible;
      this._changeDetectorRef.markForCheck();
    });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------
}
